"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaEmptyWidgetRenderHandler = _interopRequireDefault(require("./bwa-empty-widget-render-handler"));
var _utils = require("../../utils/utils");
var _constants = require("../../constants/constants");
var instance = null;
var WIDGET_READY_TIMEOUT_MS = 6000;
var VALIDATE_CHECKOUT_V3_TIMEOUT_MS = 6000;
var BwaEmptyWidget = exports["default"] = /*#__PURE__*/function () {
  function BwaEmptyWidget() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BwaEmptyWidget);
    if (instance) return instance;
    instance = this;
    this.ready = new Promise(function (resolve) {
      _this.onReady = resolve;
    });
    this.setupReadyListener();
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaEmptyWidget, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.renderHandler = new _bwaEmptyWidgetRenderHandler["default"]();
              _context.next = 3;
              return this.renderHandler.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }, {
    key: "setupReadyListener",
    value: function setupReadyListener() {
      var _this2 = this;
      var bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
      var timeout = setTimeout(function () {
        return _this2.onReady();
      }, WIDGET_READY_TIMEOUT_MS);
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data, _event$data2;
        if (event.origin !== bwaOrigin) return;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.widgetId) === _constants.IFRAME_IDS.EMPTY_WIDGET && ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.widgetMessageType) === _constants.EVENT_TYPE.CUSTOM.BWA_REPEAT_CUSTOMER_RESOLVED) {
          clearTimeout(timeout);
          _this2.onReady();
        }
      });
    }
  }, {
    key: "validateCheckoutV3",
    value: function validateCheckoutV3(checkoutId) {
      var bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
      return new Promise(function (resolve) {
        var hasResolved = false;
        var timeoutHandle;
        var resolveOnce = function resolveOnce(isAddressSaved) {
          if (hasResolved) return;
          hasResolved = true;
          clearTimeout(timeoutHandle);
          window.removeEventListener(_constants.EVENT_TYPE.MESSAGE, handleCompletionMessage);
          resolve(!!isAddressSaved);
        };
        var handleCompletionMessage = function handleCompletionMessage(event) {
          var _event$data3;
          if (event.origin !== bwaOrigin) return;
          if (((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.type) === _constants.EVENT_TYPE.CUSTOM.BWA_VALIDATE_CHECKOUT_V3_COMPLETE) {
            resolveOnce(event.data.isAddressSaved);
          }
        };
        window.addEventListener(_constants.EVENT_TYPE.MESSAGE, handleCompletionMessage);
        timeoutHandle = setTimeout(function () {
          console.warn('[BwA] validate-checkout v3 timed out; redirecting anyway');
          resolveOnce(false);
        }, VALIDATE_CHECKOUT_V3_TIMEOUT_MS);
        (0, _utils.postMessageToIframe)(_constants.IFRAME_IDS.EMPTY_WIDGET, {
          type: _constants.EVENT_TYPE.CUSTOM.BWA_VALIDATE_CHECKOUT_V3_TRIGGER,
          checkoutId: checkoutId
        });
      });
    }
  }]);
}();
//# sourceMappingURL=bwa-empty-widget.js.map
